import React, { Component } from 'react';
import { Box, Typography } from '@mui/material';
import ReportProblemIcon from '@mui/icons-material/ReportProblem';

function ErrorMessageLayout() {
  return (
    <>
      <Typography variant="h1" color="textSecondary">
        Error
      </Typography>
      <Box display="flex" alignItems="center">
        <ReportProblemIcon color="error" fontSize="large" />
        <Typography variant="h6" color="error">
          Opps! Something went wrong.
        </Typography>
      </Box>
    </>
  );
}
class ErrorBoundaries extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  static getDerivedStateFromError(_error) {
    return { hasError: true };
  }

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  componentDidCatch(error, errorMessage) {
    this.setState({ hasError: true });
  }

  render() {
    const { hasError } = this.state;
    const { children } = this.props;

    if (hasError) {
      return <ErrorMessageLayout />;
    }
    return children;
  }
}

export default ErrorBoundaries;
